export const AMARA_TEEN = 'Amara · Teen Today (SixBefore)'
export const AMARA_MENTOR = 'Future Amara · Mentor (SevenAfter)'
